import { render, staticRenderFns } from "./BusinessProcessEdit.vue?vue&type=template&id=20e1f14c&"
import script from "./BusinessProcessEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessProcessEdit.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProcessEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports